import { BOOKING_STATUS, FACILITY_STATUS, PAYMENT_STATUS } from "@/lib/constants";

const base = "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap";

export const FacilityStatusBadge = ({ status, testId }) => {
  const s = FACILITY_STATUS[status] || FACILITY_STATUS.disponibile;
  return (
    <span data-testid={testId} className={`${base} ${s.cls}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
};

export const PaymentBadge = ({ status, testId }) => {
  const s = PAYMENT_STATUS[status] || PAYMENT_STATUS.da_pagare;
  return <span data-testid={testId} className={`${base} ${s.cls}`}>{s.label}</span>;
};

export const BookingStatusBadge = ({ status, testId }) => {
  const s = BOOKING_STATUS[status] || BOOKING_STATUS.confermata;
  return <span data-testid={testId} className={`${base} ${s.cls}`}>{s.label}</span>;
};
